import { createSlice } from '@reduxjs/toolkit';

const XR_REDUCER_NAME = 'xrReducer';

const initialState = {
	isXREnabled: false,
	xrSessionType: [],
	xrOptionalFeatures: '',
};

const xrReducer = createSlice({
	name: XR_REDUCER_NAME,
	initialState,
	reducers: {
		setIsXREnabled: (_state, action) => {
			const { isXREnabled, xrSessionType, xrOptionalFeatures } =
				action.payload;
			_state.isXREnabled = isXREnabled;
			_state.xrSessionType = xrSessionType;
			_state.xrOptionalFeatures = xrOptionalFeatures;
		},
	},
});

export const { setIsXREnabled } = xrReducer.actions;

export default xrReducer.reducer;
